import * as types from '../../constants/app/userItemManageConstants';

export const userItemListRequest = ({
  searchString,
  callback,
  error,
}) => ({
  type: types.USER_ITEM_ITEM_LIST_REQUEST,
  searchString,
  callback,
  error,
});

export const itemRemoveRequest = ({
  itemId,
  callback,
  error,
}) => ({
  type: types.USER_ITEM_ITEM_REMOVE_REQUEST,
  itemId,
  callback,
  error,
})
